import { SURVEY_DIRECTION } from './common/services/utilities/surveyUtility';

export const CONTENT_TYPE_SURVEY = 'survey';

export const contentResponsesRoute =
  '/projects/:projectId/divestiture-diagnostic/:content/responses';
export const surveyRoute = `/projects/:projectId/divestiture-diagnostic/${CONTENT_TYPE_SURVEY}`;
export const surveySectionRoute = `${surveyRoute}/:sectionPath`;
export const surveyQuestionRoute = `${surveySectionRoute}/:questionId`;

export const nextRoute = `${surveyRoute}/${SURVEY_DIRECTION.NEXT}`;
export const previousRoute = `${surveyRoute}/${SURVEY_DIRECTION.PREVIOUS}`;

export const formatContentResponsesRoute = (projectId, content) =>
  contentResponsesRoute
    .replace(':projectId', projectId)
    .replace(':content', content);

export const formatSurveyRoute = (projectId) =>
  surveyRoute.replace(':projectId', projectId);

export const formatSurveySectionRoute = (projectId, sectionPath) =>
  surveySectionRoute
    .replace(':projectId', projectId)
    .replace(':sectionPath', sectionPath);

export const formatSurveyQuestionRoute = (projectId, sectionPath, questionId) =>
  surveyQuestionRoute
    .replace(':projectId', projectId)
    .replace(':sectionPath', sectionPath)
    .replace(':questionId', questionId);

export const formatNextRoute = (projectId) =>
  nextRoute.replace(':projectId', projectId);

export const formatPreviousRoute = (projectId) =>
  previousRoute.replace(':projectId', projectId);
